import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NotificationType, usePublishNotification } from '@yakoffice/notification-handler';
import { useRootStore } from './useRootStore';
import { IBuild } from '../models/Build/Builld';


export interface buildsControllerResult {
    isLoaded: boolean;
    builds: IBuild[] | null;
}

interface PropsType {
    miniclipPublicAccess: boolean;
    buildId?: string;
    buildsType: string;
    userEmail: string;
    event: number;
}


export const useBuilds = (props: PropsType) => {

    const rootStore = useRootStore();
    const publishNotification = usePublishNotification();
    const { projectId } = useParams<{ projectId: string }>();
    const effectRan = useRef(false);

    const [result, setResult] = useState<buildsControllerResult>(() => ({
        isLoaded: false,
        builds: []
    }));


    useEffect(() => {

        const abortController = new AbortController();

        setResult({ isLoaded: false, builds: [] });

        //FOR SEARCH ON BUILD ID
        if (props.buildId) {

            rootStore.buildStore.getBuild(projectId, props.buildId)
                .then(build => {
                    setResult({ isLoaded: true, builds: [build] });
                    const signal = abortController.signal;
                })
                .catch(e => {
                    // publishNotification({
                    //   title: 'Error Loading Build',
                    //   notificationType: NotificationType.Error,
                    //   message: e.toString()
                    // });

                    setResult({ isLoaded: true, builds: [] });
                });
        }

        //FOR ALL BUILDS
        else {

            rootStore.buildsStore.getBuilds(projectId, props.buildsType)
                .then(builds => {

                    setResult({ isLoaded: true, builds: builds });
                    const signal = abortController.signal;
                })
                .catch(() => {
                    setResult({ isLoaded: true, builds: [] });
                });
        }
        return () => {
            abortController.abort();
            effectRan.current = true;
        };

    }, [projectId, publishNotification, props.buildsType, props.buildId, props.event]);

    return result;
};
